import React, { useEffect, useState } from "react";
import { useSearchParams } from 'react-router-dom';
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";
import ProductCard from "../shared/ProductCard";

export default function SearchResults() {
  const [params] = useSearchParams();
  const q = (params.get("q") || "").toLowerCase().trim();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      try {
        const snap = await getDocs(collection(db, "products"));
        if (cancelled) return;
        const all = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        if (!q) {
          setProducts(all.slice(0, 50));
        } else {
          const filtered = all.filter((p) => {
            const name = (p.name || "").toLowerCase();
            const desc = (p.description || "").toLowerCase();
            const cat = (p.category || "").toLowerCase();
            return (
              name.includes(q) ||
              desc.includes(q) ||
              cat.includes(q)
            );
          });
          setProducts(filtered);
        }
      } catch (e) {
        console.error(e);
        setProducts([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => (cancelled = true);
  }, [q]);

  return (
    <div className="container main-content-padding">
      <div className="search-header-container">
        <div className="search-title">
          Search results for "{params.get("q") || ""}"
        </div>
      </div>

      {loading && (
        <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 g-3 g-md-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <div className="col" key={i}>
              <div className="product-card">
                <div className="skeleton-img-placeholder" />
              </div>
            </div>
          ))}
        </div>
      )}

      {!loading && products.length === 0 && (
        <div className="no-results-box">
          No products found.
        </div>
      )}

      {!loading && products.length > 0 && (
        <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 g-3 g-md-4">
          {products.map((p) => (
            <div key={p.id} className="col d-flex align-items-stretch">
              <ProductCard product={p} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
